var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CommonTable',{ref:"table",attrs:{"width":"150","data":_vm.tableData,"total":_vm.total,"needIndex":true,"table-json":_vm.tablejson},on:{"change":_vm.handleTableChange}})}
var staticRenderFns = []

export { render, staticRenderFns }